<template>
  <div id="app" class="home container is-fluid">
		<div class="countdown" v-show="countdown">
			{{currentProgress}}
		</div>
		<div class="container is-fixed">
			<div class="instruction-notification notification is-info" v-bind:class="{closed: !instructionsOn}">
				<span class="icon is-medium" id="toggleInstructions" v-on:click="toggle">
  				<i class="fas fa-caret-down fa-2x" v-if="instructionsOn"></i>
					<i class="fas fa-caret-right fa-2x" v-else></i>
				</span>
				<div class="content">
					<h3 class="is-medium">Slips, Trips, and Falls</h3>
				</div>
				<div class="content" v-show="state === 'waiting'">
					<p class="content instruction">
						1. As participants are joining, say:
					</p>
					<p class="content speak-instruction">
						When I start, you will see {{numRandomImages}} different random images. For each image I want you to say what you think it means about how we can avoid slips, trips, and falls.
					</p>
				</div>
				<div class="content" v-show="state === 'start'">
					<p class="content instruction">
						2. Scroll through the images to monitor what they are saying about each image. Note which ones have no answers or wrong answers that may need focus after they are done.
					</p>
				</div>
				<div class="content" v-show="state === 'review'">
					<p class="content instruction">
						3. Say:
					</p>
					<p class="content speak-instruction">
						Please take a little time to review the answers. I'll give you just a minute to see them all and then we'll talk about a few of them in particular.
					</p>
					<p class="content instruction">
						When finished individually reviewing, choose one or two to focus on. Check the focus box for a scene to make sure everyone is looking at the same thing.
					</p>
				</div>
			  <div class="field is-grouped is-grouped-right" v-show="state === 'waiting'">
					<p class="control">
						<button class="button" v-on:click="startActivity">Start Exercise</button>
					</p>
				</div>
				<div class="field is-grouped is-grouped-right" v-show="state === 'review'">
					<p class="control">
						<button class="button" v-on:click="endActivity">End Exercise</button>
					</p>
				</div>
			</div>
		</div>
    <div class="container" v-show="state === 'waiting'">
			<h5 class="content title is-medium">
        Participants
      </h5>
			<div class="tags is-medium">
	      <span class="tag"
					v-for="(p, ix) in participants"
					v-bind:key="`p-${ix}`"
				>
	        {{p.username === null ? 'anonymous' : p.username}}
	      </span>
			</div>
    </div>
		<div class="container">
		</div>
		<Scenarios
			v-bind:message="addedMessage"
			v-bind:mode="state"
			v-bind:randomSet="numRandomImages"
			v-bind:is-administrator="true"
			v-on:focus="focusScene"
		/>
  </div>
</template>

<script>
import Scenarios from '../components/Scenarios'

export default {
  name: 'admin',
	components: {
		Scenarios
	},
  data() {
    return {
      pubnub: this.$pnGetInstance(),
      channelPrefix: 'tooltalk',
      state: 'waiting',
      currentActivity: null,
      participants: [],
      actTypesUnlocked: true,
      actsUnlocked: false,
      actsBtnText: 'Push Activity',
			numRandomImages: 2,
      timerStarted: false,
      notifyTime: 10000,
      currentProgress: 0,
      actTime: 15000,
      bufferTime: 7000,
      currentTime: 24000,
      push: false,
      countdown: false,
      actLive: false,
      actDone: false,
			addedMessage: {},
			instructionsOn: true
    }
  },
  methods: {
    progressCountdown( e ) {
      this.currentProgress = Math.floor( ( this.totalActivityTime - ( e.seconds * 1000 + e.milliseconds ) ) / 100 ) / 10
    },
    endCountdown() {
      this.currentProgress = 0
      this.countdown = false
    },
    completeActivity( response ) {
      // how to find the right participant?
      const participant = this.participants.find( p => p.uuid === response.publisher )
      if ( participant ) {
        participant.correct = response.message.correct
        participant.time = response.message.time
      }
    },
    presence( response ) {
      if ( response.action === 'leave' ) this.userLeave( response )
			if ( response.action === 'state-change' ) this.userJoin( response )
			if ( response.action === 'join' ) this.userJoin( response )
    },
    startActivity() {
      this.actLive = true
      this.countdown = true
			this.state = 'start'
      this.$pnPublish( {
        channel: this.adminChannel,
        message: {
          state: 'start',
          timing: this.totalActivityTime
        }
      } )
			this.currentProgress = this.totalActivityTime/1000
			const startInterval = setInterval(() => {
				this.currentProgress -= 1
				if (this.currentProgress === 0) {
					clearInterval(startInterval)
					this.reviewActivity()
					this.endCountdown()
				}
			}, 1000)
    },
    reset() {
      this.push = false
      this.actLive = false
      this.actDone = false
			this.state = 'waiting'
      this.participants.forEach( p => {
        p.time = 0
        p.correct = false
      } )
      this.$pnPublish( {
        channel: this.adminChannel,
        message: {
          state: 'waiting'
        }
      } )
      // update state to 1
    },
		focusScene( msg ) {
			this.$pnPublish( {
        channel: this.adminChannel,
        message: {
          state: 'focus',
					name: msg.name,
					focused: msg.isFocused
        }
      } )
		},
    reviewActivity() {
      this.actLive = false
      this.actDone = true
			this.state = 'review'
      this.$pnPublish( {
        channel: this.adminChannel,
        message: {
          state: 'review'
        }
      } )
    },
		toggle() {
			this.instructionsOn =  !this.instructionsOn
		},
		endActivity() {
			this.state = 'end'
			this.$pnPublish( {
				channel: this.adminChannel,
				message: {
					state: 'end'
				}
			} )
		},
		logMessage( msg ) {
			this.addedMessage = msg
		},
    userLeave( response ) {
      this.participants = this.participants.filter( p => p.uuid !== response.uuid )
    },
    userJoin( response ) {
      const isParticipant = this.participants.find( p => p.uuid === response.publisher )
			const username = response.message && response.message.username || 'anonymous'
      if ( !isParticipant ) {
        this.participants.push( {
          username: username,
          uuid: response.publisher
        } )
      } else {
        isParticipant.username = username
        this.participants = this.participants.map( item => item )
      }
    }
  },
  computed: {
    adminChannel() {
      return `${this.channelPrefix}_admin`
    },
    messagesChannel() {
      return `${this.channelPrefix}_messages`
    },
    userChannel() {
      return `${this.channelPrefix}_users`
    },
    incomingChannels() {
      return [ this.userChannel, this.messagesChannel ]
    },
    totalActivityTime() {
      return this.actTime + this.notifyTime + this.bufferTime
    }
  },
  created() {
    // update state to 1
  },
  mounted() {
    const vue = this
    const listener = {
      message( response ) {
				if (response.channel === vue.userChannel) {
					vue.userJoin( response )
				} else if (response.channel === vue.messagesChannel) {
					vue.logMessage( response.message )
				}
      }
    }
    this.$pnSubscribe( {
      channels: this.incomingChannels,
    } )
    this.pubnub.addListener( listener )
		window.pubnub = this.pubnub
  }
}
</script>

<style lang="css">

	.instruction, .speak-instruction {
		text-align: left;
	}

	.speak-instruction {
  	quotes: "“" "”" "‘" "’";
	}
	.speak-instruction:before {
    content: open-quote;
	}
	.speak-instruction:after {
    content: close-quote;
	}


	.is-fixed {
		position: -webkit-sticky !important; /* Safari */
		position: sticky !important;
		height: auto;
		z-index: 100;
		top: 0;
		left: 0;
		width: 100%;
	}

	.is-fixed .content h3 {
		color: white;
	}

	.container.is-fixed {
		margin-bottom: 1em;
	}

	.countdown {
		position: fixed;
		bottom: 0;
		right: 0;
		background-color: rgba(0, 0, 0, .5);
		height: 2.5em;
		border-radius: 0;
		width: 2.5em;
		color: white;
		font-size: 1.5em;
		z-index: 200;
		padding: 0.5em;
	}

	#toggleInstructions {
		position: absolute;
		left: 0.2em;
		top: 0.2em;
	}

	.instruction-notification.closed {
		height: 4em;
		overflow: hidden;
	}

</style>
